import { render, staticRenderFns } from "./GestaoCarga.vue?vue&type=template&id=2bd70cb9"
import script from "./GestaoCarga.vue?vue&type=script&lang=js"
export * from "./GestaoCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports